import angular from 'angular';
import uiRouter from 'angular-ui-router';
import advertInlineAddPageComponent from './advertInlineAddPage.component';

let advertInlineAddPageModule = angular.module('advertInlineAddPage', [
  uiRouter
])

.component('advertInlineAddPage', advertInlineAddPageComponent)

.name;

export default advertInlineAddPageModule;
